import http from 'plugins/axios';

export default {
  create(data) {
    return http.post({
      url: '/admin/email/send',
      data,
      dataType: 'form'
    });
  },

  sendEmailOnTime(data) {
    return http.post({
      url: '/admin/email/send/time',
      data,
      dataType: 'form'
    });
  },

  queryMailProvider(){
    return http.get({
      url: '/admin/email/provider/query',
    })
  },

  saveMailProvider(data){
    return http.post({
      url: '/admin/email/provider/save',
      data,
      dataType: 'form'
    })
  },

  querySmsProvider(){
    return http.get({
      url: '/admin/sms/provider/query'
    })
  },

  saveSmsProvider(data){
    return http.post({
      url: '/admin/sms/provider/save',
      data,
      dataType: 'form'
    })
  }
};
